(function () {
    'use strict';

    angular
        .module('app')
        .controller('ShowTempPasswordController', ShowTempPasswordController);

        ShowTempPasswordController.$inject = ['$modalInstance', 'email', 'tempPassword', 'authentication'];

    function ShowTempPasswordController($modalInstance, email, tempPassword, authentication) {
        var vm = this;

        vm.tempPassword = tempPassword;
        vm.email = email;
    }
})();